export const FAILED_CONNECTION = 'Failed to connect to server'
export const NO_SEARCH_RESULTS = 'No search results.'
export const PAGE_NOT_FOUND = 'Page not found.'
